<template>
  <div class="home">
    <div class="content">
      <div class="w-100">
        <h3 class="page-title">需求统计</h3>
        <div class="d-f cards">
          <div class="card" :id="`card${userInfo.id}`" v-show="userInfo.isActive" v-for="(userInfo, i) in usersInfo" :key="i" :class="{a: curOpenId === userInfo.id}">
            <div class="dash-base" :class="{a: curOpenId === userInfo.id}">
              <div class="f-d-c d-user-info">
                <!-- 参考 components/User.vue 的既有约定：没有头像就不渲染 img，改显示姓名首字圆点 -->
                <img v-if="userInfo.img" :src="baseURL + userInfo.img" class="profile m-r-10">
                <span v-else class="profile name-avatar m-r-10" :style="{ background: avatarColor(userInfo.name) }">{{ avatarInitial(userInfo.name) }}</span>
                <div class="f-d-c">
                  <p class="f-s-s">{{ userInfo.bumen }}</p>
                  <p class="f-s-b">{{ userInfo.name }}</p>
                </div>
              </div>
              <h2 style="width: 100%" class="mb1">总评分</h2>
              <div class="d-score d-f mb c">
                <div class="score-item">
                  <p class="score-title">质量</p>
                  <p class="score">{{ fGrade(userInfo.avgGradeQuality) }}</p>
                </div>
                <div class="score-item">
                  <p class="score-title">速度</p>
                  <p class="score">{{ fGrade(userInfo.avgGradeSpeed) }}</p>
                </div>
                <div class="score-item">
                  <p class="score-title">沟通</p>
                  <p class="score">{{ fGrade(userInfo.avgGradeChat) }}</p>
                </div>
              </div>
              <h2 style="width: 100%" class="mb1">总体完成情况</h2>
              <div class="d-count mb">
                <div class="progress mb1">
                  <div class="progress-bar bg-suc" v-if="userInfo.countTaskDone > 0" :style="{width: userInfo.countTaskDone / userInfo.countTask * 100 + '%'}"></div>
                  <div class="progress-bar bg-default" v-if="userInfo.countTaskDoing > 0" :style="{width: userInfo.countTaskDoing / userInfo.countTask * 100 + '%'}"></div>
                </div>
                <div class="d-f legends">
                  <div>
                    <span class="legend bg-suc"></span>
                    <span>完成 {{ userInfo.countTaskDone }}</span>
                  </div>
                  <div>
                    <span class="legend bg-default"></span>
                    <span>进行 {{ userInfo.countTaskDoing }}</span>
                  </div>
                  <div>
                    <span class="legend bg-disable"></span>
                    <span>待办 {{ userInfo.countTaskTodo }}</span>
                  </div>
                </div>
              </div>
              <a @click="showDetail(userInfo.id)" v-if="curOpenId !== userInfo.id" class="btn-detail" href="javascript: void(0)">查看单月详情</a>
            </div>
            <div class="dash-detail" :class="{a: curOpenId === userInfo.id}">
              <h2 class="mb" v-if="curMonth">{{ curMonth.Format('yyyy年MM月') }}详情</h2>
              <div class="d-btns" v-if="curOpenId === userInfo.id">
                <button class="btn" @click="showDetailPrevMonth(userInfo.id)">上月</button>
                <button class="btn" @click="!isCurMonth && showDetail(userInfo.id)" :class="{'normal-btn': isCurMonth}">本月</button>
              </div>
              <div :id="`chart${userInfo.id}`" class="chart-days"></div>
              <div class="c score-and-chart">
                <div class="d-score d-f mb c" v-if="detailData.grade">
                  <h2 class="mb1">该月评分</h2>
                  <div class="d-f">
                    <div class="score-item">
                      <p class="score-title">质量</p>
                      <p class="score">{{ fGrade(detailData.grade.avgGradeQuality) }}</p></div>
                    <div class="score-item">
                      <p class="score-title">速度</p>
                      <p class="score">{{ fGrade(detailData.grade.avgGradeSpeed) }}</p></div>
                    <div class="score-item">
                      <p class="score-title">沟通</p>
                      <p class="score">{{ fGrade(detailData.grade.avgGradeChat) }}</p></div>
                  </div>
                </div>
                <div class="chart-done-detail">
                  <h2>该月完成情况</h2>
                  <div :id="`chart-task-done${userInfo.id}`"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
import { avatarColor, avatarInitial } from '@/utils/avatar'

let charts = [];
export default {
  data() {
    return {
      usersInfo: [],
      curOpenId: null,
      detailData: {
        grade: {}
      },
      curMonth: null
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isCurMonth() {
      if (!this.curMonth) return false
      let now = new Date();
      return now.getFullYear() === this.curMonth.getFullYear() && now.getMonth() === this.curMonth.getMonth();
    }
  },
  methods: {
    // 无头像兜底：与 components/User.vue 同源（@/utils/avatar），保证同一个人全站同色
    avatarColor,
    avatarInitial,
    getMonthFirstDay(monthDate) {
      return new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    },
    getMonthLastDay(monthDate) {
      return new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);
    },
    fGrade(grade) {
      let pf = parseFloat(grade);
      return isNaN(pf) ? '-' : pf.toFixed(1);
    },
    showDetailPrevMonth(userId) {
      this.curMonth.setMonth(this.curMonth.getMonth() - 1);
      this.showDetail(userId, this.curMonth.getFullYear(), this.curMonth.getMonth());
    },
    showDetail(userId, year, month) {
      this.curOpenId = userId;
      charts.forEach(item => {
        item.dispose();
      })
      charts = [];
      setTimeout(() => {
        let now = new Date();
        if (!year) {
          year = now.getFullYear();
          month = now.getMonth();
        }
        let detailDate = new Date(year, month)
        this.curMonth = detailDate;
        let postData = {
          userId: userId,
          startDate: this.getMonthFirstDay(detailDate).Format(),
          endDate: this.getMonthLastDay(detailDate).Format(),
        }
        this.$post('/dashboard/detail', postData, res => {
          console.log(res)
          res = this.fillMonth(detailDate.getFullYear(), detailDate.getMonth(), res)
          console.log(res)
          let temp = echarts.init(document.getElementById(`chart${userId}`))
          temp.setOption(this.getEchartOption(res));
          charts.push(temp);
        })
        postData.endDate = this.getMonthFirstDay(new Date(year, month + 1)).Format();
        this.$post('/dashboard/detail-task-done', postData, res => {
          let temp = echarts.init(document.getElementById(`chart-task-done${userId}`))
          let option = this.getEchartOptionTaskDetail(res);
          console.log(option);
          temp.setOption(option);
          charts.push(temp);
        })
        this.$post('/dashboard/detail-avg-grade', postData, res => {
          this.detailData.grade = res
        })
      }, 300)
    },
    getEchartOption(data) {
      let days = Array.from(data, item => item.date);
      // let dataAll = Array.from(data, item => item.countAll);
      let dataDoing = Array.from(data, item => item.countDoing);
      // let dataDone = Array.from(data, item => item.countDone);
      let dataTodo = Array.from(data, item => item.countTodo);
      // let dataCurDayDone = Array.from(data, item => item.curDayDone);
      return {
        tooltip: { trigger: 'axis', },
        legend: {
          data: ['当日完成', '正在进行', '待办']
        },
        xAxis: {
          type: 'category',
          data: days
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '正在进行',
            type: 'bar',
            stack: '总量',
            label: {
              show: true
            },
            data: dataDoing,
            itemStyle: { color: '#505f79' },
          }, {
            name: '待办',
            type: 'bar',
            stack: '总量',
            label: {
              show: true
            },
            data: dataTodo,
            itemStyle: { color: '#dcdce0' }
          },
          // {
          //   name: '当日完成',
          //   type: 'bar',
          //   stack: '总量',
          //   label: {
          //     show: true
          //   },
          //   data: dataCurDayDone,
          //   itemStyle: {color: '#02875b'}
          // },
        ]
      };
    },
    getEchartOptionTaskDetail(data) {
      return {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: '该月需完成: ' + data.needDone,
            type: 'pie',
            radius: '55%',
            roseType: 'radius',
            label: {
              show: true,
              formatter: '{b}{c} ({d}%)'
            },
            data: [
              { value: data.unDone, name: '待办', itemStyle: { color: '#dcdce0' } },
              { value: data.overtimeDone, name: '超时完成', itemStyle: { color: '#ea4545' } },
              { value: data.onTimeDone, name: '准时完成', itemStyle: { color: '#02875b' } },
            ]
          }
        ]
      };
    },
    fillMonth(year, month, data) {
      console.log(year, month, data)
      let res = [];
      let start = this.getMonthFirstDay(new Date(year, month, 1));
      let lastTotalAll = data[0].minTotalAll;
      let lastTotalDoing = data[0].minTotalDoing;
      let lastTotalDone = data[0].minTotalDone;
      let lastTotalTodo = data[0].minTotalTodo;
      let now = new Date();
      while (start.getMonth() === month) {
        let findItem = data.find(item => new Date(item.date).getTime() === start.getTime());
        if (findItem) res.push(findItem);
        else if (start.getTime() > now.getTime())
          res.push({
            date: start.Format(),
          })
        else res.push({
            date: start.Format(),
            countAll: lastTotalAll,
            countDoing: lastTotalDoing,
            countDone: lastTotalDone,
            countTodo: lastTotalTodo,
          })
        lastTotalAll = res[res.length - 1].countAll;
        lastTotalDoing = res[res.length - 1].countDoing;
        lastTotalDone = res[res.length - 1].countDone;
        lastTotalTodo = res[res.length - 1].countTodo;
        start.setDate(start.getDate() + 1);
      }
      return res;
    }
  },
  mounted() {
    this.$get('/dashboard/users', {}, res => {
      this.usersInfo = res
    })
  }
}
</script>
<style scoped>
.d-btns {
  position: absolute;
  right: 0;
  top: 0;
}

.d-btns button {

}

.mb {
  margin-bottom: 16px;
}


.mb1 {
  margin-bottom: 8px;
}

.legends > div {
  padding: 0 5px;
  white-space: nowrap;
}

.cards {
  flex-wrap: wrap;
}

.card {
  position: relative;
  height: auto;
  margin: 0 10px 20px 10px;
  width: calc(25% - 40px);
  padding: 10px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 0 0, rgba(0, 0, 0, 0.03) 0 0 0 1px;
  animation: v-left-in .3s forwards;
  transition: width .3s;
  display: flex;
  justify-content: center;
}

.card.a {
  width: calc(75% - 40px);
}

.btn-detail {
}

.t {
  height: auto;
  margin: 0 10px 20px 10px;
  width: 25%;
}

.score-and-chart {
  align-items: flex-start;
}

.dash-base {
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: box-shadow .2s ease;
}

.dash-base.a {
  box-shadow: 0 0 5px 3px #505f796e;
}

.dash-detail {
  overflow: hidden;
  padding: 0;
  width: 0;
  transition: width .3s, padding .3s, height .3s;
  height: 0;
}

.dash-detail.a {
  padding: 0 20px;
  width: 100%;
  min-width: 300px;
  border-left: 1px solid #eceef2;
  height: auto;
  position: relative;
}

.dash-detail h2 {
  text-align: center;
}

.chart-days {
  width: 100%;
  height: 300px;
}

.chart-done-detail {
  width: 65%;
}

.chart-done-detail > div {
  width: 100%;
  height: 150px;
}

.dash-base .profile {
  width: 112px;
  height: 112px;
  margin-right: 0;
  margin-bottom: 16px;
}

/* 无头像兜底：尺寸沿用 .dash-base .profile（112px），这里只补居中与字色 */
.dash-base .name-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
  flex-shrink: 0;
}

.f-s-s {
  font-size: 12px;
}

.f-s-b {
  font-size: 17px;
  font-weight: bold;
}

.d-user-info {
  margin-bottom: 16px;
}

.d-score {
  width: 35%;
}

.dash-detail .d-score {
  flex-direction: column;
}

.score-title {
  /*margin-bottom: 16px;*/
  white-space: nowrap;
}

.score-item {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.score {
  font-size: 35px;
  font-weight: 600;
}

.home {
  background-color: #f4f6fa;
}

.d-count {
  width: 100%;
}

</style>
